import { render } from "./SuccessPage.vue?vue&type=template&id=3b76c6da&scoped=true"
import script from "./SuccessPage.vue?vue&type=script&lang=js"
export * from "./SuccessPage.vue?vue&type=script&lang=js"

import "./SuccessPage.vue?vue&type=style&index=0&id=3b76c6da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b76c6da"]])

export default __exports__